<template>
	<div id="users-table">
		<table class="table" v-if="tableRows.length != 0 && !isLoadingInvestorsUsers">
			<thead class="table__header">
				<tr>
					<th
						v-for="(header, index) in tableHeader"
						@click="orderByHeader(header)"
						:class="header.field == 'edit' || header.field == 'delete' ? 'icon' : ''"
						:key="index"
					>
						<div class="row">
							<span :class="header.field == 'actions' ? '' : 'pointer'">{{ header.label }}</span>
						</div>
					</th>
				</tr>
			</thead>
			<tbody>
				<tr
					v-for="(row, index) in tableRows"
					:key="row.id"
					:class="[index % 2 == 0 ? 'stripped' : '', row.isInvalid ? 'invalid' : '']"
				>
					<td>{{ row.firstName }} {{ row.lastName }}</td>
					<td>
						{{ row.email }}
					</td>
					<td>
						{{ getCompanyName(row) }}
					</td>
					<td>
						{{ row.userRoles != null ? row.userRoles.roleName : ' - ' }}
					</td>
					<td>
						{{ row.userStatus != null ? row.userStatus.name : ' - ' }}
					</td>
					<td class="actions">
						<span @click="editRow(row)"><EditIcon :size="24" :border="'#0047ff'" /></span>
					</td>
				</tr>
			</tbody>
		</table>
		<div class="loader" v-if="isLoadingInvestorsUsers">
			<SpinnerIcon :color="'#597393'" />
		</div>
		<Pagination
			v-if="tableRows.length != 0 && !isLoadingInvestorsUsers"
			:totalPages="totalPages"
			:currentFromReq="currentPage"
			@tableRequest="tableRequest"
		/>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import SidebarArrow from '@/components/shared/Icons/SidebarArrow.vue';
import Pagination from '@/components/shared/Pagination/Pagination';
import SpinnerIcon from '@/components/shared/Icons/SpinnerIcon';
import EditIcon from '@/components/shared/Icons/EditIcon.vue';

export default {
	name: 'UsersTable',
	components: {
		SidebarArrow,
		Pagination,
		SpinnerIcon,
		EditIcon,
	},
	props: {
		isWeb: {
			required: true,
		},
		currentPage: {
			required: true,
		},
	},
	data: () => ({}),
	mounted() {},
	methods: {
		tableRequest(param) {
			this.$emit('changePage', param);
		},
		orderByHeader(param) {
			if (param.field == 'actions') return;
			this.$emit('orderByHeader', param.field);
		},
		editRow(row) {
			const investorId = this.$route.query.id;

			this.$router.push({
				path: '/dashboard/user/detail',
				query: { id: row.id, investorId },
			});
		},
		getCompanyName(row) {
			return row.investor && row.investor.name ? row.investor.name : ' - ';
		},
	},
	computed: {
		...mapGetters('investorManagement', ['investorUserList', 'isLoadingInvestorsUsers']),
		tableHeader() {
			return [
				{
					field: 'firstName',
					label: 'Nome',
				},
				{
					field: 'email',
					label: 'E-mail',
				},
				{
					field: 'investor',
					label: 'Empresa',
				},
				{
					field: 'userRoles',
					label: 'Tipo de Usuário',
				},
				{
					field: 'enable',
					label: 'Status',
				},
				{
					field: 'actions',
					label: 'Ações',
				},
			];
		},
		tableRows() {
			const rows = this.investorUserList.users != undefined ? this.investorUserList.users : [];

			return !rows.length ? [] : rows;
		},
		totalPages() {
			const pagination =
				this.investorUserList.totalPages != undefined ? this.investorUserList.totalPages : 1;

			return pagination;
		},
	},
};
</script>

<style lang="scss" scoped>
@import 'UsersTable.scss';
</style>
